import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import CustomPluginEnablerCommand from "./custompluginenablercommand";

export default class CustomPluginEnablerEditing extends Plugin {
    init() {
        const editor = this.editor;
        editor.commands.add(
            "custompluginenabler",
            new CustomPluginEnablerCommand(editor)
        );
    }
}
